module.exports = __webpack_public_path__ + "media/ui-store-purchase.4d08dc60.mp3";